export default {"src":"/_next/static/media/0x831753dd7087cac61ab5644b308642cc1c33dc13.f0346cd9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};